import TableBusinessData from './TableBusinessData';

export default TableBusinessData;